module.exports = __webpack_public_path__ + "static/img/9.77c8267.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/2/zh/9.png
// module id = cX5V
// module chunks = 0